<template>
  <div class="help-icon">
    <v-tooltip
      top
      v-bind:bottom="bottom"
      v-bind:max-width="maxWidth"
    >
      <template v-slot:activator="{ on, attrs }">
        <img
          v-if="typeIcon === 'info'"
          alt="Помощь"
          class="help-icon__image help-icon__image--info"
          src="@/assets/img/help.svg"
          v-bind:width="sizes.width"
          v-bind:height="sizes.height"
          v-bind="attrs"
          v-on="on"
        />
        <img
          v-else-if="typeIcon === 'question'"
          class="help-icon__image help-icon__image--question"
          src="@/assets/img/question-mark.svg"
          v-bind:width="sizes.width"
          v-bind:height="sizes.height"
          alt="Помощь"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    bottom: { default: false, type: Boolean },
    maxWidth: { type: Number, default: 490 },
    tooltipText: { type: String, default: '' },
    typeIcon: { type: String, default: 'info' },
    sizes: {
      type: Object,
      default: () => ({
        width: 26,
        height: 26,
      }),
    },
  },
};
</script>

<style scoped lang="scss">
.help-icon {
  display: inline-block;
  align-self: flex-start;
  &__image {
    object-fit: contain;
    &--question {
      margin: 0;
    }
  }
  span {
    text-align: center;
  }
}
</style>
